const moment = require("moment");

function generateLabel(range, date) {
  let label = [];
  let start_label = "",
    end_label = "",
    step = "";
  end_label = moment(date);
  start_label = moment(date).subtract(1, "month");
  step = "day";
  if (range === 1) {
    start_label = moment(date).subtract(1, "day");
    step = "hour";
  } else if (range === 3) {
    start_label = moment(date).subtract(1, "year");
    step = "month";
  }

  for (let i = start_label; i <= end_label; i.add(1, step)) {
    if (step === "day") {
      label.push(i.format("D"));
    } else if (step === "hour") {
      label.push(i.format("HH"));
    } else if (step === "month") {
      label.push(i.format("M"));
    }
  }
  return label;
}

function sortItemsByRange(items, range, date) {
  let itemsByRange = [];
  let start_label = "",
    end_label = "",
    step = "";
  end_label = moment(date);
  start_label = moment(date).subtract(1, "month");
  step = "day";
  if (range === 1) {
    start_label = moment(date).subtract(1, "day");
    step = "hour";
  } else if (range === 3) {
    start_label = moment(date).subtract(1, "year");
    step = "month";
  }

  for (let i = start_label; i <= end_label; i.add(1, step)) {
    let count = 0;
    if (step === "day") {
      items.filter(function (el) {
        if (
          moment(el.createdAt).format("YYYY-MM-DD") === i.format("YYYY-MM-DD")
        ) {
          count += 1;
          return true;
        }
        return false;
      });
    } else if (step === "hour") {
      items.filter(function (el) {
        if (
          moment(el.createdAt).format("HH") == i.format("HH") &&
          moment(el.createdAt).format("YYYY-MM-DD") ==
            moment(date).format("YYYY-MM-DD")
        ) {
          count += 1;
          return true;
        }
        return false;
      });
    } else if (step === "month") {
      items.filter(function (el) {
        if (moment(el.createdAt).format("YYYY-MM") === i.format("YYYY-MM")) {
          count += 1;
          return true;
        }
        return false;
      });
    }
    itemsByRange.push(count);
  }

  return itemsByRange;
}

function sortRevenuByCompletedAt(items, range, date) {
  let itemsByRange = [];
  let start_label = "",
    end_label = "",
    step = "";
  end_label = moment(date);
  start_label = moment(date).subtract(1, "month");
  step = "day";
  if (range === 1) {
    start_label = moment(date).subtract(1, "day");
    step = "hour";
  } else if (range === 3) {
    start_label = moment(date).subtract(1, "year");
    step = "month";
  }

  for (let i = start_label; i <= end_label; i.add(1, step)) {
    let count = 0;
    if (step === "day") {
      items.filter(function (el) {
        if (
          moment(el.completed_at).format("YYYY-MM-DD") ===
          i.format("YYYY-MM-DD")
        ) {
          count += 1;
          return true;
        }
        return false;
      });
    } else if (step === "hour") {
      items.filter(function (el) {
        if (
          moment(el.completed_at).format("HH") == i.format("HH") &&
          moment(el.completed_at).format("YYYY-MM-DD") ==
            moment(date).format("YYYY-MM-DD")
        ) {
          count += 1;
          return true;
        }
        return false;
      });
    } else if (step === "month") {
      items.filter(function (el) {
        if (moment(el.completed_at).format("YYYY-MM") === i.format("YYYY-MM")) {
          count += 1;
          return true;
        }
        return false;
      });
    }
    itemsByRange.push(count);
  }

  return itemsByRange;
}

module.exports.convertDataToGraph = (data, range, label, date) => {
  const labels = generateLabel(range, date);
  const datasets = [
    {
      label: label,
      pointHoverBackgroundColor: "#fff",
      borderWidth: 2,
      data: sortItemsByRange(data, range, date),
    },
  ];

  return { labels, datasets };
};

module.exports.convertDataToLineGraph = (data, range, label, date) => {
  const labels = generateLabel(range, date);
  const line = [
    {
      label: label,
      fill: false,
      lineTension: 0.1,
      backgroundColor: "rgba(75,192,192,0.4)",
      borderColor: "rgba(75,192,192,1)",
      borderCapStyle: "butt",
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: "miter",
      pointBorderColor: "rgba(75,192,192,1)",
      pointBackgroundColor: "#fff",
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: "rgba(75,192,192,1)",
      pointHoverBorderColor: "rgba(220,220,220,1)",
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: sortRevenuByCompletedAt(data, range, date),
    },
  ];

  return { labels, datasets: line };
};

module.exports.convertTwoGraph = (
  data1,
  data2,
  label1,
  label2,
  range,
  date
) => {
  const labels = generateLabel(range, date);

  const images_videos = {
    labels: labels,
    datasets: [
      {
        label: label1,
        backgroundColor: "rgba(255,99,132)",
        borderColor: "rgba(255,99,132,1)",
        borderWidth: 1,
        hoverBackgroundColor: "rgba(255,99,132,0.4)",
        hoverBorderColor: "rgba(255,99,132,1)",
        data: sortItemsByRange(data1, range, date),
      },
      {
        label: label2,
        backgroundColor: "rgba(100,99,255)",
        borderColor: "rgba(100,99,255,1)",
        borderWidth: 1,
        hoverBackgroundColor: "rgba(100,99,255,0.4)",
        hoverBorderColor: "rgba(100,99,255,1)",
        data: sortItemsByRange(data2, range, date),
      },
    ],
  };

  return images_videos;
};



// WEBPACK FOOTER //
// ./client/react/common/utils/graph.js